import i18n from "i18n";
import readableFilterUsagesSummary from "search-filter/readableFilterUsagesSummary";
const confirmActionUsagesAlert = ({
  action,
  usagesSummary,
  additionalExplanation = ""
}) => (
  // eslint-disable-next-line no-alert
  window.confirm(
    i18n.t("confirm_action_usages_alert.message", {
      ns: "enterprise_search",
      count: usagesSummary.length,
      usages: readableFilterUsagesSummary(usagesSummary),
      action: i18n.t(`confirm_action_usages_alert.${action}`, { ns: "enterprise_search" }),
      additionalExplanation,
      interpolation: { escapeValue: false }
    })
  )
);
export default confirmActionUsagesAlert;
